
interface ColumnItem {
    id: number;
    name: string;
    checked: boolean;
  }

  export const initialColumnAccount = [
    { id: 1, name: 'ACCOUNT ID', checked: true, key: 'accountNumber' }, 
    { id: 2, name: 'ACCOUNT NAME', checked: true, key: 'accountName' }, 
    { id: 4, name: 'PHONE NUMBER', checked: true, key: 'mainPhone' }, 
    { id: 5, name: 'PRIMAY CONTACT', checked: false, key: 'primaryContactName' }, 
    { id: 6, name: 'EMAIL ADDRESS', checked: true, key: 'email' }, 
    { id: 7, name: 'STATUS', checked: true, key: 'isActive' }, 

  ];
  
